module.exports = __webpack_public_path__ + "img/logo.ed0c86c4.png";